import { deleteUserFiles } from '.';
import { batchCopyService, cbForCopy, groupByRepository } from '../utils';
export default async (params, destinationRepo, destinationPath = '/', batchSize, logger) => {
    const { files } = params;
    const fileGroupedByRepository = groupByRepository(files);
    try {
        await Promise.all(fileGroupedByRepository.map(async (group) => {
            return await batchCopyService(group, cbForCopy(destinationPath, destinationRepo, { safe: true, conflictSolve: 'copy' }), batchSize, logger);
        }));
        const filesToDelete = (files[0] &&
            files
                ?.filter((file) => file.uri.includes('file://'))
                .map(({ ...keepAttrs }) => keepAttrs)) ||
            files;
        const foldersToDelete = (files[0] &&
            files
                ?.filter((folder) => folder.uri.includes('folder://'))
                .map(({ ...keepAttrs }) => keepAttrs)) ||
            [];
        await deleteUserFiles({ files: filesToDelete, purge: true, batchSize, type: 'file' }, logger);
        await deleteUserFiles({ files: foldersToDelete, purge: true, batchSize, type: 'folder' }, logger);
    }
    catch (error) {
        return error;
    }
};
